module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.3b31e1de93290779334c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/glyphicons-halflings-regular.svg
// module id = 1545
// module chunks = 2